import axios from 'axios';

const API_BASEURL = process.env.REACT_APP_API_BASEURL;

const api = axios.create({
  baseURL: API_BASEURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach JWT token to every outgoing request, if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// If the API ever returns a 401, clear the stored session so the user
// is sent back to the login screen on next render.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
    return Promise.reject(error);
  }
);

/**
 * Calls POST /auth/login with { email, password }.
 * Expected response shape: { token: string, user: { firstName, lastName, ... } }
 * Adjust the endpoint/response mapping below to match your actual API contract.
 */
export const login = async (email, password) => {
  const { data } = await api.post(`/auth/login`, { email, password });
  console.log('Login response data:', data);
  return data;
};

export const register = async (email, password, name) => {
  const { data } = await api.post(`/auth/register`, { email, password, name });
  console.log('Register response data:', data);
  return data;
};

export default api;
